import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { PropertyGroupApiData } from "../propertyGroupModal";

interface FAQSectionProps {
  formData: PropertyGroupApiData;
  onSectionChange: (field: "title" | "description", value: string) => void;
  onFAQItemChange: (index: number, field: "question" | "answer", value: string) => void;
  quillModules: any;
  quillFormats: string[];
}

const FAQSection: React.FC<FAQSectionProps> = ({
  formData,
  onSectionChange,
  onFAQItemChange,
  quillModules,
  quillFormats,
}) => {
  return (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Section Title
          </label>
          <input
            type="text"
            value={formData.questions.title}
            onChange={(e) =>
              onSectionChange("title", e.target.value)
            }
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="e.g., Frequently Asked Questions"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Section Description
          </label>
          <ReactQuill
            theme="snow"
            value={formData.questions.description}
            onChange={(value) =>
              onSectionChange("description", value)
            }
            modules={quillModules}
            formats={quillFormats}
            placeholder="e.g., Common questions about properties"
          />
        </div>
      </div>
      <div className="space-y-3 mt-4">
        <h4 className="text-md font-medium text-gray-700">
          FAQ Items
        </h4>
        {formData.questions.items.map(
          (
            faq: { question: string; answer: string },
            index: number
          ) => (
            <div
              key={index}
              className="space-y-3 p-3 border border-gray-200 rounded-md">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Question {index + 1}
                </label>
                <input
                  type="text"
                  value={faq.question}
                  onChange={(e) =>
                    onFAQItemChange(index, "question", e.target.value)
                  }
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder={`e.g., What types of properties are available?`}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Answer {index + 1}
                </label>
                <ReactQuill
                  theme="snow"
                  value={faq.answer}
                  onChange={(value) =>
                    onFAQItemChange(index, "answer", value)
                  }
                  modules={quillModules}
                  formats={quillFormats}
                  placeholder={`e.g., We offer a wide variety of properties including apartments, houses, and commercial spaces...`}
                />
              </div>
            </div>
          )
        )}
      </div>
    </>
  );
};

export default FAQSection;

